export default __webpack_public_path__ + "static/media/img-0352-central-african-full-face.0eadbdd3.png";